import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { UserSessionService } from './usersession.service';

@Injectable({
  providedIn: 'root'
})
export class PageService {
  roleId: any;

  constructor(private dataService: DataService,private session: UserSessionService) { }


  getPagesByRoleId() {
    //return this.dataService.getRecord('/api/Page/GetPagesByRoleId');
    debugger

    const sessionDataString = localStorage.getItem(
      this.session.localStorageSessionKey
    );
    debugger
    if (sessionDataString) {
      const localStorageData = JSON.parse(sessionDataString);
      this.roleId = localStorageData?.roleId;

    }

    return this.dataService.getRecord('/api/Page/GetPagesByRoleId/' + this.roleId);
  }

  getRoleControlMappingByPageAndRole(pageid: number) {
    return this.dataService.getRecord('/api/Page/GetRoleControlMappingByPageAndRole/' + pageid);
  }

  getPagesByRoleIdList() {
    return this.dataService.getRecord('/api/Page/GetPagesByRoleIdList');
  }

  getLayoutControl() {
    return this.dataService.getRecord('/api/LayoutControl/GetLayoutControls');
  }
  getLayoutControlByPageId(pageid: number) {
    return this.dataService.getRecord('/api/LayoutControl/GetLayoutControlsByPageId/' + pageid);
  }
}
